import { DeliveryState } from '../shared';
import type { Delivery } from './types';

export const STUB_DELIVERIES: Delivery[] = [
  {
    name: 'deliveries/a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    scheduledDelivery: 'scheduledDeliveries/f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    sourceLocation: 'locations/11111111-1111-1111-1111-111111111111',
    sourcePath: '/outbound/invoices/',
    targetLocation: 'locations/22222222-2222-2222-2222-222222222222',
    targetPath: '/inbound/invoices/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 3 files successfully',
    fileTransfers: [
      {
        sourceUri: 's3://hsbc-bucket/outbound/invoices/invoices_001.csv',
        targetUri: 'sftp://hsbc-server/inbound/invoices/invoices_001.csv',
        sizeBytes: 1024,
        success: true,
      },
      {
        sourceUri: 's3://hsbc-bucket/outbound/invoices/invoices_002.csv',
        targetUri: 'sftp://hsbc-server/inbound/invoices/invoices_002.csv',
        sizeBytes: 2048,
        success: true,
      },
      {
        sourceUri: 's3://hsbc-bucket/outbound/invoices/invoices_003.csv',
        targetUri: 'sftp://hsbc-server/inbound/invoices/invoices_003.csv',
        sizeBytes: 1536,
        success: true,
      },
    ],
    startTime: '2024-01-15T02:00:00Z',
    endTime: '2024-01-15T02:01:30Z',
  },
  {
    name: 'deliveries/b2c3d4e5-f6a7-8901-bcde-f23456789012',

    scheduledDelivery: 'scheduledDeliveries/e2d3c4b5-a6f7-8901-bcde-f23456789012',
    sourceLocation: 'locations/33333333-3333-3333-3333-333333333333',
    sourcePath: '/exports/',
    targetLocation: 'locations/44444444-4444-4444-4444-444444444444',
    targetPath: '/imports/',
    state: DeliveryState.DELIVERY_STATE_PENDING,
    fileTransfers: [],
    startTime: '2024-01-15T03:00:00Z',
  },
  {
    name: 'deliveries/c3d4e5f6-a7b8-9012-cdef-345678901234',

    scheduledDelivery: 'scheduledDeliveries/d3c4b5a6-f7e8-9012-cdef-345678901234',
    sourceLocation: 'locations/55555555-5555-5555-5555-555555555555',
    sourcePath: '/data/transactions/',
    targetLocation: 'locations/66666666-6666-6666-6666-666666666666',
    targetPath: '/archive/transactions/',
    state: DeliveryState.DELIVERY_STATE_FAILED,
    statusMessage: 'Connection timeout to target location',
    fileTransfers: [
      {
        sourceUri: 's3://truist-bucket/data/transactions/transactions_001.parquet',
        targetUri: 'gcs://truist-archive/archive/transactions/transactions_001.parquet',
        sizeBytes: 5120,
        success: false,
        errorMessage: 'Connection timeout',
      },
    ],
    startTime: '2024-01-13T06:00:00Z',
    endTime: '2024-01-13T06:05:00Z',
  },
  {
    name: 'deliveries/d4e5f6a7-b8c9-0123-def0-456789012345',

    scheduledDelivery: null,
    sourceLocation: 'locations/77777777-7777-7777-7777-777777777777',
    sourcePath: '/catalog/',
    targetLocation: 'locations/88888888-8888-8888-8888-888888888888',
    targetPath: '/feeds/',
    state: DeliveryState.DELIVERY_STATE_RUNNING,
    statusMessage: 'Transferring files...',
    fileTransfers: [],
    startTime: '2024-01-15T04:00:00Z',
  },
  {
    name: 'deliveries/e5f6a7b8-c9d0-1234-ef01-567890123456',

    scheduledDelivery: 'scheduledDeliveries/f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    sourceLocation: 'locations/11111111-1111-1111-1111-111111111111',
    sourcePath: '/outbound/invoices/',
    targetLocation: 'locations/22222222-2222-2222-2222-222222222222',
    targetPath: '/inbound/invoices/',
    state: DeliveryState.DELIVERY_STATE_CANCELLED,
    statusMessage: 'Cancelled by user',
    fileTransfers: [],
    startTime: '2024-01-14T02:00:00Z',
    endTime: '2024-01-14T02:00:15Z',
  },
  {
    name: 'deliveries/f6a7b8c9-d0e1-2345-f012-678901234567',

    scheduledDelivery: 'scheduledDeliveries/e2d3c4b5-a6f7-8901-bcde-f23456789012',
    sourceLocation: 'locations/33333333-3333-3333-3333-333333333333',
    sourcePath: '/exports/',
    targetLocation: 'locations/44444444-4444-4444-4444-444444444444',
    targetPath: '/imports/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 1 file successfully',
    fileTransfers: [
      {
        sourceUri: 's3://smbc-emea-bucket/exports/feedback_20240114.json',
        targetUri: 'sftp://smbc-emea/imports/feedback_20240114.json',
        sizeBytes: 4096,
        success: true,
      },
    ],
    startTime: '2024-01-14T03:00:00Z',
    endTime: '2024-01-14T03:00:45Z',
  },
  {
    name: 'deliveries/17a8b9c0-d1e2-3456-f012-789012345678',

    scheduledDelivery: 'scheduledDeliveries/f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    sourceLocation: 'locations/11111111-1111-1111-1111-111111111111',
    sourcePath: '/outbound/reports/',
    targetLocation: 'locations/22222222-2222-2222-2222-222222222222',
    targetPath: '/inbound/reports/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 5 files successfully',
    fileTransfers: [],
    startTime: '2024-01-13T02:00:00Z',
    endTime: '2024-01-13T02:02:00Z',
  },
  {
    name: 'deliveries/28b9c0d1-e2f3-4567-0123-890123456789',

    scheduledDelivery: null,
    sourceLocation: 'locations/55555555-5555-5555-5555-555555555555',
    sourcePath: '/data/payments/',
    targetLocation: 'locations/66666666-6666-6666-6666-666666666666',
    targetPath: '/archive/payments/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 2 files successfully',
    fileTransfers: [],
    startTime: '2024-01-12T14:30:00Z',
    endTime: '2024-01-12T14:31:00Z',
  },
  {
    name: 'deliveries/39c0d1e2-f3a4-5678-1234-901234567890',

    scheduledDelivery: 'scheduledDeliveries/d3c4b5a6-f7e8-9012-cdef-345678901234',
    sourceLocation: 'locations/77777777-7777-7777-7777-777777777777',
    sourcePath: '/catalog/products/',
    targetLocation: 'locations/88888888-8888-8888-8888-888888888888',
    targetPath: '/feeds/products/',
    state: DeliveryState.DELIVERY_STATE_FAILED,
    statusMessage: 'Credential failed',
    fileTransfers: [],
    startTime: '2024-01-11T08:00:00Z',
    endTime: '2024-01-11T08:00:30Z',
  },
  {
    name: 'deliveries/40d1e2f3-a4b5-6789-2345-012345678901',

    scheduledDelivery: 'scheduledDeliveries/e2d3c4b5-a6f7-8901-bcde-f23456789012',
    sourceLocation: 'locations/33333333-3333-3333-3333-333333333333',
    sourcePath: '/exports/daily/',
    targetLocation: 'locations/44444444-4444-4444-4444-444444444444',
    targetPath: '/imports/daily/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 10 files successfully',
    fileTransfers: [],
    startTime: '2024-01-10T03:00:00Z',
    endTime: '2024-01-10T03:05:00Z',
  },
  {
    name: 'deliveries/51e2f3a4-b5c6-7890-3456-123456789012',

    scheduledDelivery: null,
    sourceLocation: 'locations/11111111-1111-1111-1111-111111111111',
    sourcePath: '/outbound/settlements/',
    targetLocation: 'locations/66666666-6666-6666-6666-666666666666',
    targetPath: '/archive/settlements/',
    state: DeliveryState.DELIVERY_STATE_PENDING,
    fileTransfers: [],
    startTime: '2024-01-15T05:00:00Z',
  },
  {
    name: 'deliveries/62f3a4b5-c6d7-8901-4567-234567890123',

    scheduledDelivery: 'scheduledDeliveries/f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    sourceLocation: 'locations/22222222-2222-2222-2222-222222222222',
    sourcePath: '/inbound/confirmations/',
    targetLocation: 'locations/55555555-5555-5555-5555-555555555555',
    targetPath: '/data/confirmations/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 1 file successfully',
    fileTransfers: [],
    startTime: '2024-01-09T02:00:00Z',
    endTime: '2024-01-09T02:00:20Z',
  },
  {
    name: 'deliveries/73a4b5c6-d7e8-9012-5678-345678901234',

    scheduledDelivery: 'scheduledDeliveries/d3c4b5a6-f7e8-9012-cdef-345678901234',
    sourceLocation: 'locations/44444444-4444-4444-4444-444444444444',
    sourcePath: '/imports/reconciliation/',
    targetLocation: 'locations/77777777-7777-7777-7777-777777777777',
    targetPath: '/catalog/reconciliation/',
    state: DeliveryState.DELIVERY_STATE_RUNNING,
    statusMessage: 'Processing file 3 of 8...',
    fileTransfers: [],
    startTime: '2024-01-15T04:30:00Z',
  },
  {
    name: 'deliveries/84b5c6d7-e8f9-0123-6789-456789012345',

    scheduledDelivery: null,
    sourceLocation: 'locations/88888888-8888-8888-8888-888888888888',
    sourcePath: '/feeds/analytics/',
    targetLocation: 'locations/33333333-3333-3333-3333-333333333333',
    targetPath: '/exports/analytics/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 4 files successfully',
    fileTransfers: [],
    startTime: '2024-01-08T12:00:00Z',
    endTime: '2024-01-08T12:02:30Z',
  },
  {
    name: 'deliveries/95c6d7e8-f9a0-1234-7890-567890123456',

    scheduledDelivery: 'scheduledDeliveries/e2d3c4b5-a6f7-8901-bcde-f23456789012',
    sourceLocation: 'locations/66666666-6666-6666-6666-666666666666',
    sourcePath: '/archive/quarterly/',
    targetLocation: 'locations/11111111-1111-1111-1111-111111111111',
    targetPath: '/outbound/quarterly/',
    state: DeliveryState.DELIVERY_STATE_CANCELLED,
    statusMessage: 'Cancelled due to duplicate run',
    fileTransfers: [],
    startTime: '2024-01-07T06:00:00Z',
    endTime: '2024-01-07T06:00:10Z',
  },
  {
    name: 'deliveries/06d7e8f9-a0b1-2345-8901-678901234567',

    scheduledDelivery: 'scheduledDeliveries/f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    sourceLocation: 'locations/55555555-5555-5555-5555-555555555555',
    sourcePath: '/data/statements/',
    targetLocation: 'locations/22222222-2222-2222-2222-222222222222',
    targetPath: '/inbound/statements/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 12 files successfully',
    fileTransfers: [],
    startTime: '2024-01-06T02:00:00Z',
    endTime: '2024-01-06T02:08:00Z',
  },
  {
    name: 'deliveries/17e8f9a0-b1c2-3456-9012-789012345678',

    scheduledDelivery: null,
    sourceLocation: 'locations/77777777-7777-7777-7777-777777777777',
    sourcePath: '/catalog/inventory/',
    targetLocation: 'locations/44444444-4444-4444-4444-444444444444',
    targetPath: '/imports/inventory/',
    state: DeliveryState.DELIVERY_STATE_FAILED,
    statusMessage: 'Disk quota exceeded on target',
    fileTransfers: [],
    startTime: '2024-01-05T10:00:00Z',
    endTime: '2024-01-05T10:15:00Z',
  },
  {
    name: 'deliveries/28f9a0b1-c2d3-4567-0123-890123456789',

    scheduledDelivery: 'scheduledDeliveries/d3c4b5a6-f7e8-9012-cdef-345678901234',
    sourceLocation: 'locations/88888888-8888-8888-8888-888888888888',
    sourcePath: '/feeds/orders/',
    targetLocation: 'locations/66666666-6666-6666-6666-666666666666',
    targetPath: '/archive/orders/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 7 files successfully',
    fileTransfers: [],
    startTime: '2024-01-04T08:00:00Z',
    endTime: '2024-01-04T08:03:00Z',
  },
  {
    name: 'deliveries/39a0b1c2-d3e4-5678-1234-901234567890',

    scheduledDelivery: 'scheduledDeliveries/e2d3c4b5-a6f7-8901-bcde-f23456789012',
    sourceLocation: 'locations/33333333-3333-3333-3333-333333333333',
    sourcePath: '/exports/monthly/',
    targetLocation: 'locations/55555555-5555-5555-5555-555555555555',
    targetPath: '/data/monthly/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 3 files successfully',
    fileTransfers: [],
    startTime: '2024-01-03T03:00:00Z',
    endTime: '2024-01-03T03:01:30Z',
  },
  {
    name: 'deliveries/40b1c2d3-e4f5-6789-2345-012345678901',

    scheduledDelivery: null,
    sourceLocation: 'locations/11111111-1111-1111-1111-111111111111',
    sourcePath: '/outbound/refunds/',
    targetLocation: 'locations/88888888-8888-8888-8888-888888888888',
    targetPath: '/feeds/refunds/',
    state: DeliveryState.DELIVERY_STATE_PENDING,
    fileTransfers: [],
    startTime: '2024-01-15T06:00:00Z',
  },
  {
    name: 'deliveries/51c2d3e4-f5a6-7890-3456-123456789012',

    scheduledDelivery: 'scheduledDeliveries/f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    sourceLocation: 'locations/22222222-2222-2222-2222-222222222222',
    sourcePath: '/inbound/adjustments/',
    targetLocation: 'locations/77777777-7777-7777-7777-777777777777',
    targetPath: '/catalog/adjustments/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 2 files successfully',
    fileTransfers: [],
    startTime: '2024-01-02T02:00:00Z',
    endTime: '2024-01-02T02:00:45Z',
  },
  {
    name: 'deliveries/62d3e4f5-a6b7-8901-4567-234567890123',

    scheduledDelivery: 'scheduledDeliveries/d3c4b5a6-f7e8-9012-cdef-345678901234',
    sourceLocation: 'locations/44444444-4444-4444-4444-444444444444',
    sourcePath: '/imports/credits/',
    targetLocation: 'locations/33333333-3333-3333-3333-333333333333',
    targetPath: '/exports/credits/',
    state: DeliveryState.DELIVERY_STATE_RUNNING,
    statusMessage: 'Connecting to target...',
    fileTransfers: [],
    startTime: '2024-01-15T04:45:00Z',
  },
  {
    name: 'deliveries/73e4f5a6-b7c8-9012-5678-345678901234',

    scheduledDelivery: null,
    sourceLocation: 'locations/66666666-6666-6666-6666-666666666666',
    sourcePath: '/archive/disputes/',
    targetLocation: 'locations/11111111-1111-1111-1111-111111111111',
    targetPath: '/outbound/disputes/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 1 file successfully',
    fileTransfers: [],
    startTime: '2024-01-01T12:00:00Z',
    endTime: '2024-01-01T12:00:30Z',
  },
  {
    name: 'deliveries/84f5a6b7-c8d9-0123-6789-456789012345',

    scheduledDelivery: 'scheduledDeliveries/e2d3c4b5-a6f7-8901-bcde-f23456789012',
    sourceLocation: 'locations/55555555-5555-5555-5555-555555555555',
    sourcePath: '/data/accruals/',
    targetLocation: 'locations/44444444-4444-4444-4444-444444444444',
    targetPath: '/imports/accruals/',
    state: DeliveryState.DELIVERY_STATE_FAILED,
    statusMessage: 'File format validation failed',
    fileTransfers: [],
    startTime: '2023-12-31T06:00:00Z',
    endTime: '2023-12-31T06:00:15Z',
  },
  {
    name: 'deliveries/95a6b7c8-d9e0-1234-7890-567890123456',

    scheduledDelivery: 'scheduledDeliveries/f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    sourceLocation: 'locations/88888888-8888-8888-8888-888888888888',
    sourcePath: '/feeds/commissions/',
    targetLocation: 'locations/22222222-2222-2222-2222-222222222222',
    targetPath: '/inbound/commissions/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 6 files successfully',
    fileTransfers: [],
    startTime: '2023-12-30T02:00:00Z',
    endTime: '2023-12-30T02:04:00Z',
  },
  {
    name: 'deliveries/06b7c8d9-e0f1-2345-8901-678901234567',

    scheduledDelivery: null,
    sourceLocation: 'locations/77777777-7777-7777-7777-777777777777',
    sourcePath: '/catalog/pricing/',
    targetLocation: 'locations/66666666-6666-6666-6666-666666666666',
    targetPath: '/archive/pricing/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 8 files successfully',
    fileTransfers: [],
    startTime: '2023-12-29T08:00:00Z',
    endTime: '2023-12-29T08:06:00Z',
  },
  {
    name: 'deliveries/17c8d9e0-f1a2-3456-9012-789012345678',

    scheduledDelivery: 'scheduledDeliveries/d3c4b5a6-f7e8-9012-cdef-345678901234',
    sourceLocation: 'locations/33333333-3333-3333-3333-333333333333',
    sourcePath: '/exports/reversals/',
    targetLocation: 'locations/88888888-8888-8888-8888-888888888888',
    targetPath: '/feeds/reversals/',
    state: DeliveryState.DELIVERY_STATE_CANCELLED,
    statusMessage: 'Source location unavailable',
    fileTransfers: [],
    startTime: '2023-12-28T03:00:00Z',
    endTime: '2023-12-28T03:00:05Z',
  },
  {
    name: 'deliveries/28d9e0f1-a2b3-4567-0123-890123456789',

    scheduledDelivery: 'scheduledDeliveries/e2d3c4b5-a6f7-8901-bcde-f23456789012',
    sourceLocation: 'locations/11111111-1111-1111-1111-111111111111',
    sourcePath: '/outbound/allocations/',
    targetLocation: 'locations/55555555-5555-5555-5555-555555555555',
    targetPath: '/data/allocations/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 15 files successfully',
    fileTransfers: [],
    startTime: '2023-12-27T02:00:00Z',
    endTime: '2023-12-27T02:12:00Z',
  },
  {
    name: 'deliveries/39e0f1a2-b3c4-5678-1234-901234567890',

    scheduledDelivery: null,
    sourceLocation: 'locations/44444444-4444-4444-4444-444444444444',
    sourcePath: '/imports/forecasts/',
    targetLocation: 'locations/77777777-7777-7777-7777-777777777777',
    targetPath: '/catalog/forecasts/',
    state: DeliveryState.DELIVERY_STATE_SUCCEEDED,
    statusMessage: 'Delivered 4 files successfully',
    fileTransfers: [],
    startTime: '2023-12-26T10:00:00Z',
    endTime: '2023-12-26T10:02:00Z',
  },
];
